import { LogosGridOptionsType } from "@/types/ModuleOptionsType";
import { Section } from "../../components/Section/Section";
import styles from "./LogosGrid.module.scss";
import {
  getItemWidthBreakpoints,
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { fetchLogos, LogosCardElementType } from "./fetchLogos";
import { useRouter } from "next/router";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { HeaderLogoType } from "@/types/PageType";
import { LogoCard } from "../../components/LogoCard/LogoCard";
import { Modul_Logo_Grid } from "../../wp/types/acf-module-types";
import { columnSize } from "../../utils/layout/columnSize";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import buttonStyles from "../../components/Button/Button.module.scss";
import { Headline } from "@/components/Headline/Headline";
import { mockLogo } from "@/ui/mock-data";

export type LogosGridModuleType = Modul_Logo_Grid;

interface LogosGridProps {
  data: LogosGridModuleType;
  logosGridOptions: LogosGridOptionsType;
}

export type LogosGridDataType = {
  totalPosts: number;
  elements: HeaderLogoType[];
};

const LogosGridModule = ({ data, logosGridOptions }: LogosGridProps) => {
  const {
    background_color_class,
    headline_text_align_class,
    id,
    section_margin_class,
    section_padding_class,
    module_width,
    grid_columns,
    posts_per_page,
  } = data.layout;
  const {
    columns,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_overline_subline,
    grayscale,
    grid_options: { grid_navigation, grid_columns_choices },
    box_color,
  } = logosGridOptions ?? {};

  const { headline, headline_html_tag, overline, subline } =
    data.logos_grid || {};
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  const { locale, defaultLocale } = useRouter();

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }
  const fallbackItemWidth = {
    mobile: 1,
    tablet: 2,
    desktop: 3,
    widescreen: 4,
    fullhd: 5,
    ultrahd: 6,
  };
  const itemWidth = getItemWidthBreakpoints(
    grid_columns_choices,
    grid_columns,
    fallbackItemWidth,
  );
  const GridJSX = (
    <Grid
      // key={refreshKey}
      postsPerPage={posts_per_page}
      fetchItems={({ page, postsPerPage, offset }) => {
        return fetchLogos({
          page,
          postsPerPage,
          offset,
          module: data,
          locale,
          defaultLocale,
        });
      }}
      renderLoading
    >
      {(gridLogos, loading) => {
        return (
          <>
            <GridContent justifyContent="center" gap="2rem">
              {gridLogos.map((logo, key) => {
                return (
                  <GridItem itemWidth={itemWidth.result} key={key}>
                    <LogoCard
                      skeleton={loading}
                      key={key}
                      element={
                        loading ? mockLogo : (logo as LogosCardElementType)
                      }
                      show_border_radius={show_border_radius}
                      show_box_shadow={show_box_shadow}
                      showBox={show_card_box}
                      boxBackgroundColor={box_color || ""}
                      grayscale={grayscale}
                    />
                  </GridItem>
                );
              })}
              {/* jscpd:ignore-start */}
            </GridContent>
            <GridLoadMore
              grid_navigation={grid_navigation}
              buttonStyles={buttonStyles}
            />
          </>
        );
      }}
    </Grid>
  );

  return (
    <Section
      className={`is-clipped ${styles["posts-grid"]} ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      frameless={module_width === "frameless"}
      columnsClassName="is-centered is-multiline"
      id={id}
    >
      {
        <div
          className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
        >
          <div>
            {headline && (
              <Headline
                headline_html_tag={headline_html_tag}
                headline={headline}
                extraClass={headline_text_align_class}
                overline={showOverline ? overline : ""}
                subline={showSubline ? subline : ""}
                wrapInSection={module_width === "frameless"}
                disableAnimation
              />
            )}
          </div>
          {GridJSX}
        </div>
      }
    </Section>
  );
  /* jscpd:ignore-end */
};

export default LogosGridModule;
